<template>
    <v-container>
        <ModuleBar title="ADMINISTRAR PORCENTAJES" />

        <v-row>
            <v-col>
                <v-card outlined>
                    <v-card-title>
                        <v-list>
                            <v-row v-if="synchronizing">
                                <v-col>
                                    <v-progress-circular indeterminate width="2" size="40" color="primary" />
                                </v-col>
                            </v-row>
                            <v-list-item v-else>
                                <v-list-item-content>
                                    <v-list-item-title>Monto a repartir: {{ amount_percentage.toLocaleString('es-PE', {
                                        style: 'currency',
                                        currency: 'PEN'
                                    }) }}</v-list-item-title>
                                    <v-list-item-subtitle>Dato extraído del cierre del: {{ closeDate
                                        }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-title>
                    <v-card-text>
                        <v-col>
                            <v-btn text color="primary" :loading="synchronizing" @click="synchronizeDrop">Sincronizar
                                datos del sistema
                                drop</v-btn>
                            <v-btn text color="primary" @click="openDialogEmployee">agregar empleado</v-btn>
                            <!-- <v-btn text color="primary">Historico de porcentajes</v-btn> -->
                        </v-col>
                        <v-col>
                            <span>{{ `(${employeeSelected.length})` }} {{ employeeSelected.length > 1 ? ` Empleados van
                                a
                                cobrar el porcentaje`: ` Empleado va a cobrar el porcentaje` }}</span>
                            <v-list>
                                <template v-for="employee, key in employeeSelected">
                                    <v-list-item :key="key" v-if="employeeSelected">
                                        <v-list-item-avatar>
                                            <v-img :src="employee.photo_url" :lazy-src="employee.photo_thumb_url" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ employee.names }}
                                                {{ employee.last_names }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>{{ employee.avatar }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            {{ total }}
                                        </v-list-item-action>
                                        <v-list-item-action>
                                            <v-btn icon @click="deleteEmployee(key)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider v-if="key + 1 != employeeSelected.length" :key="`div${key}`" />
                                </template>
                            </v-list>
                        </v-col>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn text color="primary" @click="process" :loading="loadingProcess">Procesar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog width="800" v-model="dialogEmployee" persistent max-height="600">
            <search-employee @closeDialogSearchEmployee="closeDialogSearchEmployee" :employeeSelected="employeeSelected"
                :lider="lider" :searchAll="true" @addEmployee="addEmployee" />
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../../components/General/ModuleBar.vue';
import SearchEmployee from '../../components/Forms/searchEmployee.vue';
import bus from '../../events/bus.js';

export default {
    components: { ModuleBar, SearchEmployee },

    data() {
        return {
            loadingProcess: false,
            employeeSelected: [],
            lider: 0,
            employees: null,
            dialogEmployee: false,
            amount_percentage: 0,
            closeDate: "",
            synchronized: false,
            synchronizing: false,
            total: 0,
        }
    },

    methods: {
        openDialogEmployee() {
            this.dialogEmployee = true;
        },

        closeDialogEmployee() {
            this.dialogEmployee = false;
        },

        closeDialogSearchEmployee() {
            this.dialogEmployee = false;
        },

        addEmployee(employee) {
            this.employeeSelected.push(employee);
            this.totalCU();
        },

        synchronizeDrop() {
            this.synchronizing = true;
            this.employeeSelected = [];

            setTimeout(() => {
                this.$store.dispatch('findCloseAction').then((res) => {
                    this.amount_percentage = res.amount_percentage ? res.amount_percentage : 0;
                    this.closeDate = res.created_at;
                    this.$store.dispatch('findLastPercentageAction').then((res) => {

                        let payload = {
                            ids: res.employee_ids,
                        }

                        this.$store.dispatch('findEmployeesByPercentegesAction', payload).then((res) => {
                            this.employeeSelected = res;
                            this.synchronized = true;
                            this.synchronizing = false;
                            this.totalCU();
                        });
                    });
                });
            }, 500);
        },

        totalCU() {
            let cant = this.employeeSelected.length;
            if (cant == 0) {
                return 0;
            }
            let total = this.amount_percentage / cant;

            let totalCU = total.toLocaleString('es-PE', {
                style: 'currency',
                currency: 'PEN'
            });
            this.total = totalCU;
        },

        deleteEmployee(key) {
            this.employeeSelected.splice(key, 1);
            this.totalCU();
        },

        process() {
            if (this.amount_percentage == 0) {
                bus.$emit("snackbar", {
                    color: "red",
                    text: "El monto a repartir no puede ser 0",
                });
            } else if (this.employeeSelected.length == 0) {
                bus.$emit("snackbar", {
                    color: "red",
                    text: "No hay empleados seleccionados",
                });
            } else {
                this.loadingProcess = true;
                let ids = [];

                this.employeeSelected.forEach(element => {
                    ids += element.id + ",";
                });

                ids += "0";

                let payload = {
                    ids: ids,
                    amount: this.amount_percentage,
                }

                setTimeout(() => {
                    this.$store.dispatch('processPercentageAction', payload).then(() => {
                        this.loadingProcess = false;
                        this.clear();
                    })
                }, 500);


            }
        },

        clear() {
            this.employeeSelected = [];
            this.lider = 0;
            this.employees = null;
            this.dialogEmployee = false;
            this.amount_percentage = 0;
            this.closeDate = "";
            this.synchronized = false;
            this.synchronizing = false;
            this.total = 0;
        }
    }
}
</script>